"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _peractoEditorUi = require("@peracto/peracto-editor-ui");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TextForm = function TextForm(_ref) {
  var _onChange = _ref.onChange,
      _ref$state = _ref.state,
      _ref$state$maxWidth = _ref$state.maxWidth,
      maxWidth = _ref$state$maxWidth === void 0 ? 100 : _ref$state$maxWidth,
      _ref$state$blockAlign = _ref$state.blockAlignment,
      blockAlignment = _ref$state$blockAlign === void 0 ? 'left' : _ref$state$blockAlign;
  var blockAlignmentOptions = [{
    label: 'Left',
    value: 'left'
  }, {
    label: 'Center',
    value: 'center'
  }, {
    label: 'Right',
    value: 'right'
  }];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.Slider, {
    label: "Max Width (".concat(maxWidth, "%)"),
    min: 10,
    max: 100,
    step: 10,
    value: maxWidth,
    onChange: function onChange(e) {
      return _onChange({
        maxWidth: e.target.value
      });
    }
  }), maxWidth < 100 && /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.Select, {
    label: "Block Alignment",
    value: blockAlignment,
    onChange: function onChange(e) {
      return _onChange({
        blockAlignment: e.value
      });
    },
    options: blockAlignmentOptions
  }));
};

var _default = TextForm;
exports["default"] = _default;